//@flow
import TrackJs from './trackjs-interface';

// Save functions in a queue and run them once heap is ready
const FUNCTIONS_QUEUE = [];
const QUEUE_INTERVAL = global.InServer ? null : setInterval(_runQueue, 100);

function _runQueue() {
  if (!global.heap) return;
  FUNCTIONS_QUEUE.forEach((fun) => fun());
  FUNCTIONS_QUEUE.length = 0;
  if (QUEUE_INTERVAL) clearInterval(QUEUE_INTERVAL);
}

function addToFunctionsQueue(funName:string, args:Object) {
  FUNCTIONS_QUEUE.push(() => callHeapFunction(funName, ...args));
}
//-----------------------------------------------------------------------------


function callHeapFunction(funName:string, ...args:any) {
  try {
    if (global.inServer) return;
    if (!global.heap) return addToFunctionsQueue(funName, args);
    global.heap[funName].apply(global.heap, args);
  } catch (e) {
    TrackJs.console.debug(`error: ${e}`);
    TrackJs.track(`Error heap ${funName} function`);
  }
}

export default {
  track(eventName:string, properties?:Object) {
    return callHeapFunction('track', eventName, properties);
  },

  identify(id:string) {
    return callHeapFunction('identify', id);
  },

  addEventProperties(properties:Object = {}) {
    return callHeapFunction('addEventProperties', properties);
  },

  addUserProperties(properties:Object = {}) {
    return callHeapFunction('addUserProperties', properties);
  },

  getUserId() {
    return global.heap && global.heap.userId;
  },

  getIdentity() {
    return global.heap && global.heap.identity;
  },
};
